import React from 'react';
import { Formik } from "formik";
import { Spin } from 'antd';
import styled from 'styled-components';
import Payment from "../../../flowManager/steps/Payment";
import CustomModal from "../../../components/UI/CustomModal";
import * as yup from "yup";
import useScreenSize from '../../../helpers/hooks/useScreenSize';
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import { useDispatch, useSelector } from 'react-redux';
import { setLoadingType } from '@arboxappv4/shared/src/redux/siteSlice';
import { updateToastMessage } from '@arboxappv4/shared/src/redux/stepperSlice';
import { LOADING_PAYMENT } from '@arboxappv4/shared/src/constants/constants';
import { t } from 'i18next';

const UpdateCreditCard = (props) => {
    const { isOpen, onClose, membershipUser, patchCard, ...rest } = props;
    const {isMobile} = useScreenSize()
    const dispatch = useDispatch()
    const paymentLoading = useSelector(state => state.site.loadingType) === LOADING_PAYMENT

    const initialValues = { payment_info: null, membershipUserId: membershipUser.id, cart: null };

    const validationSchema = yup.object().shape({
        payment_info: yup.object().required(),
    })
    
    const submitStep = (values) => {
        try {
            patchCard?.(membershipUser.id, values.res.user_box_token)
            dispatch(updateToastMessage({content: membershipUser.debt > 0 ? t('credit-card-updated-success-with-debt') : t('credit-card-updated-success'), title: t('success')}))
            dispatch(setLoadingType(null))
            onClose()
        } catch (error) {
            console.log('error', error)
            dispatch(updateToastMessage({content: t('credit-card-updated-error'), title: t('error')}))
            dispatch(setLoadingType(null))
        }
    }

    return (
    <CustomModal open={isOpen} onClose={onClose} width={isMobile ? '100%' : '90%'}
        styles={{
            ...(isMobile ? {wrapper: {height: '100%'}} : {}),
            content: {backgroundColor: Colors.siteBg, height: isMobile ? '100%' : '85%'},
            header: {backgroundColor: Colors.siteBg},
            body: {height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: Colors.siteBg},
        }}
        {...rest}>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={submitStep}>
            {({ handleSubmit, ...formikRest }) => (
                <div style={{position: 'relative', width: '100%', height: '100%', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, backgroundColor: Colors.siteBg}}>
                    <Payment handleSubmit={handleSubmit} flowType={'UPDATE_CREDIT_CARD'} {...formikRest} />
                    {paymentLoading && (
                        <PaymentLoaderOverlay>
                            <Spin spinning tip={t('payment-loader-label')} style={{height: '100%'}}>
                                <div style={{width: '100%', height: '100%'}} />
                            </Spin>
                        </PaymentLoaderOverlay>
                    )}
                </div>
            )}
        </Formik>
    </CustomModal>
    )
};

export default UpdateCreditCard;

const PaymentLoaderOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 10;
    background: ${Colors.siteBg};
`;
